<div class="container">
    <h1>No Surveys Available</h1>
    <p>We currently don’t have any surveys for you to complete. Please check back later!</p>
</div>